import React, { PropTypes } from 'react';
import { Dropdown, Form, Input } from 'semantic-ui-react';
import ReferenceDropdown from 'common/components/ReferenceDropdown';
import MultiReferenceCheckbox from 'common/components/MultiReferenceCheckbox';
import ComplexList from '../../common/ComplexList';

const AnnexDiagnosis = ({
  onValueChange,
  taskDiagnosis,
  timeUnits,
  contractTypes,
  simpleList1Ref,
  simpleList2Ref,
  complexListRef,
  conf,
  dirty,
}) => {
  const timeUnitOptions = timeUnits.map(tu => ({
    key: tu.id,
    text: tu.label,
    value: tu.id,
  }));

  const onNumberValueChange = field => (event, data) => {
    onValueChange(field)(event, { ...data, value: parseInt(data.value, 10) });
  };

  const formClassName = dirty ? 'dirty' : '';

  console.log(taskDiagnosis);

  return (
    <Form className={formClassName}>
      <Form.Group>
        <ReferenceDropdown
          refs={contractTypes}
          onChange={onValueChange('contract_type_ref')}
          title="Type de contrat"
          value={taskDiagnosis.contract_type_ref}
          width={'11'}
        />
        {conf &&
          conf.simpleField1.isActivated &&
          !conf.simpleField1.hideOnNewDemand && (
            <Form.Field width={5}>
              <label>{conf.simpleField1.label}</label>
              <Input
                value={taskDiagnosis.field_value1 || ''}
                onChange={onValueChange('field_value1')}
              />
            </Form.Field>
          )}
      </Form.Group>
      <Form.Group>
        {conf &&
          conf.simpleField2.isActivated &&
          !conf.simpleField2.hideOnNewDemand && (
            <Form.Field width={5}>
              <label>{conf.simpleField2.label}</label>
              <Input
                value={taskDiagnosis.field_value2 || ''}
                onChange={onValueChange('field_value2')}
              />
            </Form.Field>
          )}
        {taskDiagnosis.visit_evaluation && (
          <Form.Field width={5}>
            <label>Fréquence de visite</label>
            <Input
              value={taskDiagnosis.visit_evaluation.frequency || ''}
              onChange={onValueChange('visit_evaluation.frequency')}
            />
          </Form.Field>
        )}
        {taskDiagnosis.visit_evaluation && (
          <Form.Field width={6}>
            <label>Durée moyenne des visites</label>
            <Input
              label={
                <Dropdown
                  value={taskDiagnosis.visit_evaluation.average_time_unit_ref}
                  onChange={onValueChange(
                    'visit_evaluation.average_time_unit_ref'
                  )}
                  options={timeUnitOptions}
                />
              }
              labelPosition="right"
              type="number"
              value={taskDiagnosis.visit_evaluation.average_time || ''}
              onChange={onNumberValueChange('visit_evaluation.average_time')}
            />
          </Form.Field>
        )}
      </Form.Group>
      {conf &&
        conf.complexListField.isActivated &&
        !conf.complexListField.hideOnNewDemand && (
          <ComplexList
            label={conf.complexListField.label}
            title1={conf.complexListField.subLabel1}
            title2={conf.complexListField.subLabel2}
            values={
              (taskDiagnosis.complex_list &&
                taskDiagnosis.complex_list.complex_refs) ||
              []
            }
            references={complexListRef}
            onChangeValues={onValueChange('complex_list.complex_refs')}
          />
        )}
      {conf &&
        conf.simpleListField1.isActivated &&
        !conf.simpleListField1.hideOnNewDemand && (
          <MultiReferenceCheckbox
            label={conf.simpleListField1.label}
            values={
              (taskDiagnosis.simple_list1 && taskDiagnosis.simple_list1.ids) ||
              []
            }
            otherValue={
              taskDiagnosis.simple_list1 && taskDiagnosis.simple_list1.other
            }
            references={simpleList1Ref}
            onChangeValues={onValueChange('simple_list1.ids')}
            onChangeOther={onValueChange('simple_list1.other')}
            withOther
          />
        )}
      {conf &&
        conf.simpleListField2.isActivated &&
        !conf.simpleListField2.hideOnNewDemand && (
          <MultiReferenceCheckbox
            label={conf.simpleListField2.label}
            values={
              (taskDiagnosis.simple_list2 && taskDiagnosis.simple_list2.ids) ||
              []
            }
            otherValue={
              taskDiagnosis.simple_list2 && taskDiagnosis.simple_list2.other
            }
            references={simpleList2Ref}
            onChangeValues={onValueChange('simple_list2.ids')}
            onChangeOther={onValueChange('simple_list2.other')}
            withOther
          />
        )}
      <Form.TextArea
        label="Commentaire lié à l’activité"
        value={taskDiagnosis.customer_directive || ''}
        onChange={onValueChange('customer_directive')}
      />
    </Form>
  );
};

AnnexDiagnosis.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  taskDiagnosis: PropTypes.object.isRequired,
  timeUnits: PropTypes.array.isRequired,
  contractTypes: PropTypes.array.isRequired,
  simpleList1Ref: PropTypes.array.isRequired,
  simpleList2Ref: PropTypes.array.isRequired,
  complexListRef: PropTypes.array.isRequired,
  conf: PropTypes.object,
};

export default AnnexDiagnosis;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/AnnexDiagnosis.js